<template>
  <div>
    <div class="attachment-section mt-2" v-if="attachmentData.length">
      <v-card
        v-for="file in attachmentData"
        :key="file.file_name"
        class="float-left mr-2 mb-2"
        :width="size && size == 'small' ? '100px' : '140px'"
      >
        <v-hover v-slot="{ hover }">
          <v-img
            :lazy-src="file.file_url"
            :src="
              file.file_type == 'application/pdf'
                ? require(`@/assets/img/pdf.svg`)
                : file.file_type == 'application/msword'
                ? require(`@/assets/img/doc.svg`)
                : file.file_url
            "
            :width="size && size == 'small' ? '100px' : '140px'"
            :height="size && size == 'small' ? '80px' : '110px'"
            class="white--text align-end cursor-pointer"
            v-track="'preview-file'"
            @click="getPreviewFile(file)"
          >
            <v-card-title class="text-h6 transparent-background pa-1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="caption text-ellipsis text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                    >{{ file.file_name }}
                  </span>
                </template>
                <span class="caption text-capitalize"
                  >{{ file.file_name }}
                </span>
              </v-tooltip>

              <div class="align-self-center">
                <v-btn
                  :color="transparent"
                  v-if="hover"
                  fab
                  small
                  class="fixed-icon"
                  v-track="'download-file'"
                  @click.stop="downloadFile(file)"
                >
                  <v-icon
                    :class="{ 'show-btns': hover }"
                    size="20px"
                    color="white"
                  >
                    mdi-download
                  </v-icon>
                </v-btn>
              </div>
            </v-card-title>
          </v-img>
        </v-hover>
      </v-card>
    </div>
    <v-dialog v-model="filePreviewDialog" max-width="50%">
      <v-card class="pa-2 py-3">
        <v-toolbar elevation="0" height="30px" class="mb-4">
          <v-card-title class="text-md-body-1 body-2 font-weight-regular">
            <span
              class="text-capitalize text-truncate"
              style="max-width: 400px"
            >
              {{ previewFile.file_name }}
            </span>
          </v-card-title>

          <v-spacer></v-spacer>
          <v-btn
            @click.stop="downloadFile(previewFile)"
            download
            small
            icon
            class="pa-2 mx-2"
            v-track="'download-from-preview-file'"
          >
            <v-icon color=""> mdi-download </v-icon>
          </v-btn>
          <v-btn
            class="pa-2 mx-2"
            v-track="'close-file-preview'"
            rounded
            icon
            small
            @click="filePreviewDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="body-2">
          <!-- <iframe
            v-if="previewFile.file_type == 'application/pdf'"
            :src="previewFile.file_url + '.json' + '&embedded=true'"
            width="100%"
            height="650px"
            target="_blank"
          ></iframe> -->

          <v-img
            :lazy-src="previewFile.file_url"
            :src="previewFile.file_url"
            class="white--text align-end"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { $tickets } from "@/services/Index";

export default {
  props: {
    fileData: [Object, Array],
    size: String,
  },
  data() {
    return {
      filePreviewDialog: false,
      previewFile: {},
      transparent: "rgba(0, 0, 0, 0.5)",
      attachmentData: [],
    };
  },
  mounted() {
    this.attachmentData = this.fileData.attachment_info;
  },
  methods: {
    getPreviewFile(file) {
      if (
        file.file_type !== "application/msword" &&
        file.file_type !== "application/pdf"
      ) {
        this.previewFile = file;
        this.filePreviewDialog = true;
      }
    },

    downloadFile(file) {
      $tickets
        .getFile(file.download_url + ".json", { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          //   this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.transparent-background {
  background-color: rgba(0, 0, 0, 0.6);
}
.attachment-section {
  overflow: hidden !important;
}
.fixed-icon {
  position: absolute;
  right: 2px;
  top: 5px !important;
  padding: 0px !important;
}
.fixed-icon.v-btn--fab.v-size--small {
  height: 30px !important;
  width: 30px !important;
}
</style>
